import { useMemo } from "react"
import { addressHelpers } from "../../../../../features/address"
import { DataTypeList } from "../../../../../features/data-types"
import { PanelWrapper, Column, FieldType, UIPermission, FieldValue } from "../../../../../features/ui"
import { useSystemStateHooks } from "../../../../system"
import { useBranchLoaders } from "../../../loaders/branchLoaders"

export const BranchList = () => {
    const { describeAddress } = addressHelpers
    const { userHasPermission } = useSystemStateHooks()
    const readOnly = !userHasPermission(UIPermission.SAVE_BRANCHES)

    const branchLoaders = useBranchLoaders()

    const rows = useMemo(() => branchLoaders().findAllBranches().map(branch => ({
        ...branch,
        address: describeAddress(branch.address)
    })), [])

    const columns: Column[] = [
        {
            name: 'code',
            type: FieldType.TEXT,
            label: 'Código' },
        {
            name: 'name',
            type: FieldType.TEXT,
            label: 'Nombre' },
        {
            name: 'address',
            type: FieldType.TEXT,
            label: 'Dirección'
        }
    ]

    return (
        <PanelWrapper title="Sucursales" wide>
            <DataTypeList
                columns={columns}
                rows={rows}
                readOnly={readOnly}
                minItems={1}
            />
        </PanelWrapper>
    )
}
